import * as React from 'react';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import { TextField } from '@mui/material';

export default function SearchField(props) {
    const {handleSearch, width, hotSearch } = props;
    const [campo, setCampo] = React.useState('');

    React.useEffect(() =>{
      if( hotSearch){
        handleClick();
      }
    }, [hotSearch, campo])
    const handleClick=(e)=>{
      if(handleSearch) handleSearch(campo)
    }

    function  handleOnChange(e){
      setCampo(e.target.value);
    }

    return (
<Paper
      component="div"
      sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: width?width:400 }}
    >
      <InputBase
        autoFocus
        sx={{ ml: 1, flex: 1 }}
        value={campo}
        onChange={handleOnChange}
        onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.stopPropagation();
                handleClick(e);
              }
        }}
        placeholder="Filtro"
        inputProps={{ 'aria-label': 'Filtro' }}
      />
      <IconButton sx={{ p: '10px' }} aria-label="search" onClick={handleClick}>
        <SearchIcon />
      </IconButton>
    </Paper>
    )
};
